module.exports = __webpack_public_path__ + "img/tkn-tokens.0d49a15d.png";